const Validation = {
  textinputValidator(value) {
      return /^[\p{L}\p{M}\s'.-]+$/u.test(value);
  },
  numberinputValidator(value) {
      return /^[0-9]+$/.test(value);
  },
  numberInputWithDecimalValidator(value) {
      return /^\d*\.?\d*$/.test(value);
  },
  mobileNumberValidator(value) {
      return /^[0-9]{10}$/.test(value);
  },
  emailValidator(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  },
  passwordValidator(value) {
      return /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,24}$/.test(value);
  },
  confirmPasswordValidator(password, confirmPassword) {
      return password === confirmPassword;
  },
  pincodeValidator(value) {
      return /^[0-9]{5,6}$/.test(value);
  }
};

export default Validation;
